<template>
  <ConfirmDialog />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Configuraciones</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Canchas / Recursos</span>
    </li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Canchas
          <Badge size="xlarge" severity="success">{{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          v-if="'Recurso Crear' in auth.user.permissions"
          label="NUEVO"
          icon="pi pi-plus"
          class="p-button-outlined mr-2 p-button-lg"
          v-tooltip.top="'Nueva Cancha'"
          @click="openNuevo"
        />
      </div>
    </div>

    <div class="mt-4">
      <DataTable
        ref="dtrecursos"
        :value="recursos"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :rowHover="true"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} canchas"
        responsiveLayout="scroll"
        @row-dblclick="editRecurso($event.data)"
        selectionMode="single"
        showGridlines
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="buscar['global'].value" placeholder="Buscar cancha..." />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>

        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid">No existen Registros!</span>
        </template>

        <Column header="#">
          <template #body="slotProps">{{ 1 + slotProps.index }}</template>
        </Column>

        <Column field="nombre" header="NOMBRE"></Column>

        <Column header="COLOR">
          <template #body="{ data }">
            <div class="flex align-items-center gap-2">
              <span
                :style="{
                  display: 'inline-block',
                  width: '28px',
                  height: '28px',
                  borderRadius: '6px',
                  background: data.color,
                  border: '1px solid #dee2e6'
                }"
              ></span>
              <span
                :style="{
                  background: data.color,
                  color: data.text_color,
                  padding: '3px 12px',
                  borderRadius: '4px',
                  fontWeight: '600',
                  fontSize: '12px'
                }"
              >
                {{ data.nombre }}
              </span>
            </div>
          </template>
        </Column>

        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              {{ data.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
            </span>
          </template>
        </Column>

        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              icon="pi pi-ellipsis-v"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <RecursoCreate
      :show="recursoDialog"
      :recurso="recurso"
      @closeModal="ocultarDialog"
      @actualizarListado="cargarRecursos"
    />
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import RecursoService from '@/service/RecursoService'
import { useAuth } from '@/stores'
import RecursoCreate from '@/module/recursos/RecursoCreate.vue'

export default {
  components: { RecursoCreate },

  data() {
    return {
      recursos: [],
      cargando: true,
      recursoDialog: false,
      recurso: {},
      buscar: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      totalRegistros: 0,
      claseEstado: ['status-outofstock', 'status-instock']
    }
  },

  recursoService: null,
  auth: null,

  created() {
    this.auth = useAuth()
    this.recursoService = new RecursoService()
  },

  mounted() {
    this.cargarRecursos()
  },

  methods: {
    acciones(datos) {
      const permisos = this.auth.user.permissions
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          disabled: !('Recurso Editar' in permisos),
          command: () => this.editRecurso(datos)
        },
        {
          label: 'Eliminar',
          icon: 'pi pi-trash',
          disabled: !('Recurso Eliminar' in permisos),
          command: () => this.deleteRecurso(datos.id)
        }
      ]
    },

    cargarRecursos() {
      this.cargando = true
      this.recursoService.getAll().then((data) => {
        this.recursos = data.recursos || []
        this.cargando = false
      })
    },

    openNuevo() {
      this.recurso = { estado: 1 }
      this.recursoDialog = true
    },

    editRecurso(datos) {
      this.recurso = { ...datos }
      this.recursoDialog = true
    },

    ocultarDialog() {
      this.recursoDialog = false
      this.recurso = {}
    },

    deleteRecurso(id) {
      this.$confirm.require({
        message: '¿Está seguro que desea eliminar esta cancha?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sí, eliminar',
        rejectLabel: 'No, cancelar',
        acceptClass: 'p-button-danger',
        accept: () => {
          this.recursoService.delete(id).then((res) => {
            if (res.status === 200) {
              this.$toast.add({ severity: 'success', summary: 'Éxito', detail: res.mensaje, life: 3000 })
              this.cargarRecursos()
            } else {
              this.$toast.add({ severity: 'error', summary: 'Error', detail: res.mensaje, life: 3000 })
            }
          })
        }
      })
    }
  },

  watch: {
    recursos() {
      this.totalRegistros = this.recursos.length
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>